import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getWfaSessionComponents } from 'src/apps/wfa/services/WfaDashboardService';
import { TWfaSessionComponentsResult } from 'src/apps/wfa/services/WfaDashboardServiceTypes';
import { WFA_SESSION_COMPONENTS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { ITableQueryParams } from 'src/common/types/TableQueryTypes';

import { IUseTableQueryParams } from '../../../common/types/UseTableQueryParamsType';

interface IUseWfaSessionComponentsQuery extends IUseTableQueryParams {
	sessionId: string;
}

export const useWfaSessionComponentsQuery = ({
	sessionId,
	page,
	filters,
	pageSize,
	sort
}: IUseWfaSessionComponentsQuery): UseQueryResult<TWfaSessionComponentsResult> => {
	const componentsQuery = useQuery(
		[WFA_SESSION_COMPONENTS, sessionId, filters, sort, page, pageSize],
		async (): Promise<TWfaSessionComponentsResult> =>
			getWfaSessionComponents({
				sessionId,
				filterOptions: filters as ITableQueryParams['filterOptions'],
				sort,
				page,
				pageSize
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return componentsQuery;
};
